module.exports = __webpack_public_path__ + "img/festivalWishes.d976c725.webp";